module.exports = __webpack_public_path__ + "img/whatsapp2.c03d7072.png";